import { t } from "@lingui/macro";

import {
  Text,
  HStack,
  Pressable,
} from "@whoosh/design-system/src/components/primitive";

type Props = {
  isViewMoreVisible: boolean;
  isQueueSlot: boolean;
  viewMore: boolean;
  setViewMore: (value: boolean) => void;
};

export const BookingHeader = ({
  isViewMoreVisible,
  isQueueSlot,
  viewMore,
  setViewMore,
}: Props) => {
  return (
    <HStack justifyContent="space-between" alignItems="center">
      <Text variant="mainHeading" color="text-primary">{t`Your Booking`}</Text>
      {isViewMoreVisible && !isQueueSlot ? (
        <Pressable onPress={() => setViewMore(!viewMore)}>
          <Text variant="mainTiny" color="text-secondary">
            {viewMore ? t`VIEW LESS` : t`VIEW MORE`}
          </Text>
        </Pressable>
      ) : null}
    </HStack>
  );
};
